/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
 *
 *****************************************************************************/

import React, { useEffect, useState } from "react";
import { SALoader } from "../../loader/SALoader";
import Footer from "../../footer/Footer";
import { activateEmployee, activateOwner, createSubscriber } from "../../network";
import { string } from "../../constant/string";
import { useUser } from "../../context/UserContext";
import { useAuth } from "../../context/AuthContext";

/**
 * Activaing account called in Wrapper.js
 *
 * @param {*} setPage State for current page
 * @returns JSX for activating account
 */
const ActivatingAccount = ({ setPage, isInvited }) => {
  // State for loader
  const [loading, setLoading] = useState(false);
  //State to set user data from user context
  const { userData, setUserData } = useUser("");
  // State to set token from auth context
  const { token } = useAuth("");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (isInvited) {
      // Call api to activate employee account
      callApiToActivateEmployee();
    } else {
      // Call api to activate owner account
      callApiToCreatesubscriber();
    }
  }, []);

  /**
   * Api to create subscriber
   */
  const callApiToCreatesubscriber = () => {
    setLoading(true);
    //set auth header

    createSubscriber(config)
      .then((response) => {
        if (response.status == 200) {
          callApiToActivateOwner();
        }
        setLoading(false);
      })
      .catch(() => {
        setPage("AccountFailed");
        setLoading(false);
      });
  };

  /**
   * Api to activate owner
   */
  const callApiToActivateOwner = () => {
    //set auth header

    activateOwner(config)
      .then(() => {
        setPage("AccountActivated");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setPage("AccountFailed");
      });
  };

  /**
   * Api to activate employee
   */
  const callApiToActivateEmployee = () => {
    setLoading(true);
    //set auth header

    activateEmployee(config)
      .then(() => {
        setPage("AccountActivated");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setPage("AccountFailed");
      });
  };

  return (
    <div className="finalPageMain">
      {/* Parant container */}
      <div className="parantContainer">
        {/* Loader for the page */}
        <div className="mainText">
          <SALoader />
          {/* Main text on the screen */}
          {string.ACTIVATING_YOUR_ACCOUNT} <br />
          <br />
          <div className="paraText">
            {string.PLEASE_WAIT} <br />
            <br /> {string.WILL_TAKE_TIME} <br />
            <br /> {string.DO_NOT_REFRESH}
          </div>
        </div>
      </div>
      {/* Footer on the screen */}
      <Footer />
    </div>
  );
};

export default ActivatingAccount;
